import { render } from "./PlanSetupComponent.vue?vue&type=template&id=3060f624&scoped=true"
import script from "./PlanSetupComponent.vue?vue&type=script&lang=js"
export * from "./PlanSetupComponent.vue?vue&type=script&lang=js"

import "./PlanSetupComponent.vue?vue&type=style&index=0&id=3060f624&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3060f624"]])

export default __exports__